module.exports = __webpack_public_path__ + "static/assets/02db543cf9edca0d3e0e2cca9011cc19.svg";